interface FilterIconProps {
  className?: string
}

export const FilterIcon = ({ className }: FilterIconProps) => {
  return (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 3.66663H7.66667M11 3.66663H16M13.5 6.16663V1.16663M3.5 7.83329H11M6.83333 12H8.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
